module.exports = __webpack_public_path__ + "img/31.6ae3da6c.png";